import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";
import {AccountsContextService} from "../../../commons/services/accounts-context.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class FavouriteAccountButtonCtrl implements IController {

  account: AccountModel;
  favouriteAccountId: string;
  onSave: Function;

  constructor(private splitService: SplitService, private accountsContextService: AccountsContextService) {
  }

  onSetFavouriteSiteAccount(account: AccountModel) {
    const currentFavouriteAccountId = this.accountsContextService.getFavouriteAccountId(this.splitService.getSiteId());
    const updatedFavouriteAccount = currentFavouriteAccountId === account.id ? undefined : account;

    this.accountsContextService.setFavouriteAccountId(this.splitService.getSiteId(), updatedFavouriteAccount?.id);
    if (_.isFunction(this.onSave)) {
      this.onSave({account: updatedFavouriteAccount});
    }
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('favouriteAccountButton', {
    bindings: {
      account: '<',
      favouriteAccountId: '<',
      onSave: '&?'
    },
    template: require('./favourite-account-button.html').default,
    controller: FavouriteAccountButtonCtrl
  });
